export default "__VITE_ASSET__21dc0691__"